var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLearnStudioFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.198 12.135l-.394.394a5.556 5.556 0 107.836-7.836l-.394.394a5 5 0 11-7.047 7.048zm4.08-6.58A.278.278 0 0012 5.279a3.615 3.615 0 00-3.611 3.61.278.278 0 10.555 0A3.059 3.059 0 0112 5.834a.278.278 0 00.278-.277zm4.15-1.65a6.666 6.666 0 01-3.872 11.625v.581h2.222a.556.556 0 010 1.111H9.222a.556.556 0 110-1.11h2.222v-.582a6.649 6.649 0 01-4.918-2.834l1.204-1.204a5 5 0 016.873-6.872l.402-.403.802-.802a6.6 6.6 0 01.62.49zM3.11 8.056c0-.46.373-.833.833-.833h2.5v1.111H4.222v9.445h-1.11V8.056zm11.1 10.292l7.333.009a.416.416 0 01.457.372l-.02.855c0 .23-.186.417-.416.417H2.416A.416.416 0 012 19.583v-.833c0-.23.186-.417.416-.417l7.354.009v.13c0 .23.186.417.416.417h3.608c.23 0 .416-.187.416-.417v-.125zm5.846-11.125h-.834v1.111h.556v9.445h1.11V8.056a.833.833 0 00-.832-.834z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnStudioFill);
export default __webpack_public_path__ + "a58dff9b59a1d73199b35cedf23216e6.svg";
export { ForwardRef as ReactComponent };